module.exports = __webpack_public_path__ + "static/img/ico_2.ca41334.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconos/ico_2.svg
// module id = ZPts
// module chunks = 1